import { render, staticRenderFns } from "./WooCommerce.vue?vue&type=template&id=00fd0414"
import script from "./WooCommerce.vue?vue&type=script&lang=js"
export * from "./WooCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports